module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "navTabs"
    }
  }, [_c('li', {
    staticClass: "viewTabLi active",
    attrs: {
      "id": "configuration-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#configuration-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("configuration")
      }
    }
  }, [_vm._v("Configuration")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "tenantInfo-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#tenantInfo-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("tenantInfo")
      }
    }
  }, [_vm._v("Tenant Info")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi",
    attrs: {
      "id": "assemblies-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#assemblies-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("assemblies")
      }
    }
  }, [_vm._v("Assemblies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "configuration-tab"
    }
  }, [(_vm.activeTab == 'configuration') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.configuration) ? _c('table', {
    staticClass: "table table-condensed table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.configuration), function(info) {
    return _c('tr', [_c('td', [_vm._v("\n                                            " + _vm._s(info.key) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(info.value) + "\n                                        ")])])
  }), 0)]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tenantInfo-tab"
    }
  }, [(_vm.activeTab == 'tenantInfo') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.tenantInfo) ? _c('table', {
    staticClass: "table table-condensed table-striped table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.tenantInfo), function(info) {
    return _c('tr', [_c('td', [_vm._v("\n                                            " + _vm._s(info.key) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(info.value) + "\n                                        ")])])
  }), 0)]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "assemblies-tab"
    }
  }, [(_vm.activeTab == 'assemblies') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.value) ? _c('table', {
    staticClass: "table table-condensed table-striped table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(info) {
    return _c('tr', [_c('td', [_vm._v("\n                                            " + _vm._s(info.item1) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(info.item2) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(info.item3) + "\n                                        ")])])
  }), 0)]) : _vm._e()])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Site Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Assembly")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Compiled")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5348ae10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5348ae10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/site-info/site-info.vue.html
// module id = 1106
// module chunks = 0